import _axios from '@/util/httpConfig.js'
//获取页面标题
export const getPageTitle = () => { 
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "pageSize": 999,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F"
  }
  return _axios('POST', '/common-content/contentResource/list', '', data)
}

/**
 * 获取模块子目录
 * @param parentResourceCode
 * @returns {*}
 */
export const getModuleInfo = (parentResourceCode) => { //获取二级
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "moduleName": "",
    "pageNo": 0,
    "pageSize": 1000,
    "parentResourceCode": parentResourceCode,
    "resourceName": "",
    "status": "E",
    "tenantCode": "96F307B9D0EDF9F"
  }
  return _axios('POST', '/common-content/contentModule/list', '', data)
}
export const getModuleType = (moduleCode) => { //获取二级
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "pageNo": 0,
    "pageSize": 10,
    "moduleCode": moduleCode,
    "typeName": "",
    "tenantCode": "96F307B9D0EDF9F"
  }
  return _axios('POST', '/common-content/contentType/list', '', data)
}
// 获取中间卡片标题
export const getResource = (parentResourceCode) => { //获取二级
  const data = {
    appCode: "APPAFBB8CD316AFF62",
pageNo: 1,
pageSize: 10,
parentResourceCode: parentResourceCode,
resourceName: "",
tenantCode: "96F307B9D0EDF9F",
  }
  return _axios('POST', '/common-content/contentResource/list', '', data)
}
/**
 * 获取子目录对应根列表
 * @param moduleCode
 * @param contentType
 * @returns {*}
 */
export const getModuleChild = (moduleCode, contentType) => {  //获取三级
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": moduleCode,
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 10,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', `/common-content/${contentType}/list`, '', data)
}


/**
 * 获取详情内容通过get方式
 * @param contentCode
 * @param contentType
 * @returns {*}
 */
export const getInfoByGet = (contentCode, contentType = 'contentAnnounce') => {
  return _axios('GET', `/common-content/${contentType}/get?contentCode=${contentCode}&tenantCode=96F307B9D0EDF9F`)
}

/**
 * 获取详情内容通过post方式
 * @param contentCode
 * @param contentType
 * @returns {*}
 */
export const getInfoByPost = (contentCode, contentType = 'contentAnnounce') => {  //企业服务  三级
  return _axios('POST', `/common-content/${contentType}/get?contentCode=${contentCode}&tenantCode=96F307B9D0EDF9F`)
}




// WEBPACK FOOTER //
// ./src/api/moduleContent.js